import { Container } from "react-bootstrap";

const Roadmap = () => {
  return (
    <div className="roadmap">
      <Container>
        <img src="assets/roadmap.png" alt="" className="img-fluid" />
      </Container>
    </div>
  );
};
export default Roadmap;
